export default __webpack_public_path__ + "static/create-annotation-light-mode-b21a81a1c8d0d24da12cfef401384746.mp4";